 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COUVERTURE from '@/components/couverture'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DEDICATION from '@/components/dedication'
 import A from '@/components/8'
 import A5 from '@/components/75'
 import A50 from '@/components/150'
 import A00 from '@/components/200'
 import LOVE_2 from '@/components/love_2'
 import DOONESBURY from '@/components/doonesbury'
 import COPYRIGHT from '@/components/copyright'
 import AUTHORBIO from '@/components/authorbio'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/couverture",
 			"name" : "couverture",
 			"component" : COUVERTURE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/8",
 			"name" : "8",
 			"component" : A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js